import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./redux/root";
import axios from "axios";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { checkTokenExp, logout } from "./utils/checkTokenExp";

const root = ReactDOM.createRoot(document.getElementById("root"));

//Setting AXIOS and token
// axios.defaults.baseURL = "https://oserpb.herokuapp.com/v1/";
axios.defaults.baseURL = process.env.REACT_APP_API;

// Request interceptor - Add token to every request and check if token is expired
axios.interceptors.request.use(
	(config) => {
		const accessToken = localStorage.getItem("access-token");
		
		// Check if token exists and is valid
		if (accessToken) {
			if (!checkTokenExp(accessToken)) {
				// Token is expired, logout user
				console.log("Token expired, logging out...");
				logout();
				return Promise.reject(new Error("Token expired"));
			}
			config.headers.Authorization = `Bearer ${accessToken}`;
		}
		
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor - Handle 401 and token expiry
axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response) {
			// Handle 401 Unauthorized or 403 Forbidden
			if (error.response.status === 401 || error.response.status === 403) {
				console.log("Unauthorized access, logging out...");
				logout();
			}
		}
		return Promise.reject(error);
	}
);

root.render(
	<Provider store={store}>
		<App />
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
const configuration = {
	onUpdate: (registration) => {
		if (registration && registration.waiting) {
			if (
				window.confirm("New version available!  refresh to update your app?")
			) {
				registration.waiting.postMessage({ type: "SKIP_WAITING" });
				window.location.reload();
			}
		}
	},
};
serviceWorkerRegistration.register(configuration);
// reportWebVitals();
